{
  "__review_clinicalData": "Backend/clinician-authored API data (allergen/medication/problem/provider/result names, values, units, ranges, comments, message bodies) — Phase 9, do not translate",
  "enums": {
    "appointmentStatus": {
      "scheduled": "Dijadwalkan",
      "confirmed": "Dikonfirmasi",
      "completed": "Selesai",
      "cancelled": "Dibatalkan",
      "no-show": "Tidak hadir",
      "checked-in": "Telah daftar"
    },
    "resultStatus": {
      "final": "Final",
      "preliminary": "Sementara",
      "corrected": "Dikoreksi"
    },
    "allergySeverity": {
      "severe": "Berat",
      "high": "Tinggi",
      "moderate": "Sedang"
    },
    "nationalIdType": {
      "NRIC": "NRIC (Singapura)",
      "HKID": "HKID (Hong Kong)",
      "MyKad": "MyKad (Malaysia)",
      "Aadhaar": "Aadhaar (India)",
      "KTP": "KTP (Indonesia)",
      "Passport": "Paspor"
    },
    "messageSenderType": {
      "provider": "Penyedia",
      "patient": "Pasien"
    }
  },
  "form": {
    "validation": {
      "passwordMismatch": "Kata sandi tidak cocok",
      "passwordMinLength": "Kata sandi harus minimal 8 karakter"
    }
  },
  "labels": {
    "abnormal": "Abnormal"
  },
  "pages": {
    "layout": {
      "nav": {
        "myHealth": "Kesehatan Saya",
        "results": "Hasil",
        "appointments": "Janji Temu",
        "messages": "Pesan",
        "forms": "Formulir"
      },
      "signOut": "Keluar",
      "signOutAria": "Keluar",
      "navAria": "Navigasi portal",
      "footer": "Portal Pasien VynaEMR — FLOSTEL Healthcare IT"
    },
    "login": {
      "subtitle": "Portal Pasien",
      "labels": {
        "email": "Email",
        "password": "Kata sandi"
      },
      "placeholders": {
        "email": "you@example.com",
        "password": "Masukkan kata sandi Anda"
      },
      "button": {
        "signIn": "Masuk",
        "signingIn": "Sedang masuk..."
      },
      "toast": {
        "welcome": "Selamat datang kembali!",
        "invalid": "Email atau kata sandi tidak valid"
      },
      "links": {
        "noAccount": "Belum punya akun?",
        "register": "Daftar"
      }
    },
    "dashboard": {
      "greeting": {
        "morning": "Selamat pagi",
        "afternoon": "Selamat siang",
        "evening": "Selamat malam",
        "fallbackName": "Anda"
      },
      "subtitle": "Berikut ringkasan kesehatan Anda.",
      "error": "Ringkasan kesehatan Anda tidak dapat dimuat. Silakan coba lagi nanti.",
      "demographics": {
        "ageLabel": "Usia {{age}}",
        "bloodTypeLabel": "Golongan darah: {{bloodType}}"
      },
      "quickLinks": {
        "results": "Hasil",
        "appointments": "Janji Temu",
        "messages": "Pesan",
        "forms": "Formulir"
      },
      "sections": {
        "allergies": "Alergi",
        "activeMedications": "Obat Aktif",
        "activeProblems": "Masalah Aktif",
        "upcomingAppointments": "Janji Temu Mendatang",
        "recentResults": "Hasil Terbaru",
        "immunizations": "Imunisasi",
        "emergencyContact": "Kontak Darurat"
      },
      "states": {
        "noAllergies": "Tidak ada alergi yang tercatat.",
        "noMedications": "Tidak ada obat aktif.",
        "noAppointments": "Tidak ada janji temu mendatang.",
        "noResults": "Tidak ada hasil terbaru."
      },
      "moreCount": "+{{count}} lainnya",
      "sinceDate": "sejak {{date}}",
      "doseNumber": "Dosis {{number}}",
      "viewAll": "Lihat semua",
      "providerTBD": "Dokter belum ditentukan"
    },
    "register": {
      "subtitle": "Buat akun Anda",
      "labels": {
        "fullName": "Nama Lengkap",
        "email": "Email",
        "dateOfBirth": "Tanggal Lahir",
        "phone": "Telepon",
        "mrn": "MRN (Nomor Rekam Medis)",
        "idType": "Jenis Identitas",
        "idNumber": "Nomor Identitas",
        "password": "Kata sandi",
        "confirmPassword": "Konfirmasi Kata sandi"
      },
      "placeholders": {
        "fullName": "Nama lengkap Anda",
        "email": "you@example.com",
        "phone": "+65 9123 4567",
        "mrn": "e.g. P0000000001",
        "idNumber": "Nomor identitas Anda",
        "password": "Minimal 8 karakter",
        "confirmPassword": "Masukkan ulang kata sandi Anda",
        "selectIdType": "Pilih..."
      },
      "mrnHint": "Untuk menautkan akun Anda ke rekam medis, masukkan MRN atau Nomor Identitas Anda.",
      "button": {
        "createAccount": "Buat Akun",
        "creatingAccount": "Sedang membuat akun..."
      },
      "toast": {
        "success": "Pendaftaran berhasil. Silakan masuk.",
        "failure": "Pendaftaran gagal. Silakan coba lagi."
      },
      "links": {
        "haveAccount": "Sudah punya akun?",
        "signIn": "Masuk"
      },
      "aria": {
        "dateOfBirth": "Tanggal Lahir"
      }
    },
    "appointments": {
      "title": "Janji Temu",
      "subtitle": "Lihat dan kelola janji temu Anda",
      "error": "Janji temu tidak dapat dimuat. Silakan coba lagi nanti.",
      "sections": {
        "upcoming": "Mendatang",
        "past": "Sebelumnya"
      },
      "states": {
        "noUpcoming": "Tidak ada janji temu mendatang.",
        "noPast": "Tidak ada janji temu sebelumnya."
      },
      "reasonLabel": "Alasan: {{reason}}",
      "instructionsLabel": "Instruksi: {{instructions}}",
      "durationMinutes": "{{minutes}} menit",
      "actions": {
        "cancel": "Batalkan",
        "confirmCancel": "Konfirmasi",
        "cancelling": "Membatalkan...",
        "keep": "Jangan Batalkan"
      },
      "toast": {
        "cancelSubmitted": "Permintaan pembatalan telah dikirim. Tim perawatan Anda akan mengonfirmasi.",
        "cancelFailed": "Gagal membatalkan janji temu. Silakan hubungi kantor."
      }
    },
    "results": {
      "title": "Hasil Saya",
      "subtitle": "Lihat hasil laboratorium dan pencitraan Anda",
      "error": "Hasil tidak dapat dimuat. Silakan coba lagi nanti.",
      "referenceRange": "(Ref: {{range}})",
      "states": {
        "noResults": "Tidak ada hasil tersedia."
      }
    },
    "messages": {
      "title": "Pesan",
      "subtitle": "Berkomunikasi dengan tim perawatan Anda",
      "error": "Pesan tidak dapat dimuat. Silakan coba lagi nanti.",
      "fromSender": "dari {{name}}",
      "labels": {
        "subject": "Subjek",
        "message": "Pesan",
        "reply": "Balasan"
      },
      "placeholders": {
        "subject": "Subjek pesan",
        "message": "Ketik pesan Anda...",
        "reply": "Ketik balasan Anda..."
      },
      "actions": {
        "newMessage": "Pesan Baru",
        "back": "Kembali ke daftar pesan",
        "sendMessage": "Kirim Pesan",
        "sendReply": "Kirim Balasan",
        "sending": "Mengirim..."
      },
      "states": {
        "noMessages": "Belum ada pesan."
      },
      "thread": {
        "fromSenderWithType": "Dari {{name}} ({{type}})"
      },
      "compose": {
        "title": "Pesan Baru",
        "subtitle": "Pesan Anda akan dikirim ke tim perawatan Anda."
      },
      "toast": {
        "sent": "Pesan terkirim",
        "sendFailed": "Gagal mengirim pesan"
      }
    },
    "forms": {
      "title": "Formulir",
      "subtitle": "Lengkapi formulir dan kuesioner yang diperlukan",
      "error": "Tidak dapat memuat formulir. Silakan coba lagi nanti.",
      "sections": {
        "pending": "Belum Selesai",
        "completed": "Selesai"
      },
      "labels": {
        "required": "Wajib"
      },
      "placeholders": {
        "select": "Pilih..."
      },
      "actions": {
        "fillOut": "Isi",
        "back": "Kembali ke formulir",
        "submit": "Kirim Formulir",
        "submitting": "Mengirim..."
      },
      "states": {
        "noPending": "Tidak ada formulir yang belum selesai.",
        "noCompleted": "Tidak ada formulir yang sudah selesai.",
        "noFields": "Formulir ini tidak memiliki bidang untuk diisi."
      },
      "toast": {
        "submitted": "Formulir berhasil dikirim",
        "submitFailed": "Gagal mengirim formulir"
      }
    }
  }
}
